import * as yup from 'yup';

export const getDefaultUserValidationValues = (initialData) => ({
  // rut: '55.555.555-5',
  // email: 'felix.prieto@dox.cl',
  rut: '',
  email: '',
  ...initialData,
});

const UserValidationSchema = yup
  .object({
    rut: yup
      .string()
      .test('len', 'La longitud es de 9 caracteres', (val) => {
        if (val === undefined) {
          return true;
        }

        const clean_val = val.replaceAll('-', '').replaceAll('.', '');

        // return new RegExp(/^\d{8}[A-Za-z]$/).test(clean_val);
        return new RegExp(/^\d{9}$/).test(clean_val);
      })
      .required('Requerido'),
    email: yup
      .string()
      .required('Requerido. Ingrese el mismo correo que usó en la firma.')
      .email(
        'Debe ser un correo electrónico válido. Ingrese el mismo correo que usó en la firma.',
      ),
  })
  .required();

export default UserValidationSchema;
